exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-navigation-menu {\n  display: flex;\n  justify-content: space-between;\n  padding: 32px;\n}\n.page-navigation-menu__content {\n  display: flex;\n  align-items: center;\n  font-size: 18px;\n  height: 40px;\n}\n.page-navigation-menu__content > span {\n  color: #a7a8aa;\n  font-weight: 400;\n}\n.page-navigation-menu__content__title {\n  display: flex;\n  align-items: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/PageNavigation/PageNavigation.less
// module id = 887
// module chunks = 0